"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datePart_1 = require("./datePart");
var easterDict = [];
/**
 * zwraca nazwę świeta z wybranego dnia
 * @param date
 * @returns
 */
function dateHoliday(date) {
    var m = datePart_1.default(date, 'M');
    var d = datePart_1.default(date, 'd');
    if (m == 1 && d == 1)
        return "Nowy Rok"; // Nowy Rok
    if (m == 1 && d == 6)
        return "Trzech Króli"; // Nowy Rok
    if (m == 5 && d == 1)
        return "Święto Pracy"; // 1 maja
    if (m == 5 && d == 3)
        return "Święto Konstytucji 3 Maja"; // 3 maja
    if (m == 8 && d == 15)
        return "Wniebowzięcie Najświętszej Maryi Panny"; // Wniebowzięcie Najświętszej Marii Panny, Święto Wojska Polskiego
    if (m == 11 && d == 1)
        return "Wszystkich Świętych"; // Dzień Wszystkich Świętych
    if (m == 11 && d == 11)
        return "Święto Niepodległości"; // Dzień Niepodległości
    if (m == 12 && d == 25)
        return "Boże Narodzenie"; // Boże Narodzenie
    if (m == 12 && d == 26)
        return "Boże Narodzenie"; // Boże Narodzenie
    if (m >= 3 && m <= 6) {
        var y = datePart_1.default(date, 'y');
        var easter = easterDict[y];
        if (easter == undefined) {
            var a = y % 19;
            var b = y % 4;
            var c = y % 7;
            var d_1 = (a * 19 + 24) % 30;
            var e = (2 * b + 4 * c + 6 * d_1 + 5) % 7;
            if (d_1 == 29 && e == 6)
                d_1 -= 7;
            if (d_1 == 28 && e == 6 && a > 10)
                d_1 -= 7;
            var dt = new Date(y, 2, 22 + d_1 + e);
            var poniedzialek = new Date(dt.valueOf());
            poniedzialek.setDate(dt.getDate() + 1);
            var zieloneswiatki = new Date(dt.valueOf());
            zieloneswiatki.setDate(dt.getDate() + 49);
            var bozecialo = new Date(dt.valueOf());
            bozecialo.setDate(dt.getDate() + 60);
            easterDict[y] = easter = {
                wielkanoc: [dt.getFullYear(), dt.getMonth() + 1, dt.getDate()],
                poniedzialek: [poniedzialek.getFullYear(), poniedzialek.getMonth() + 1, poniedzialek.getDate()],
                zieloneswiatki: [zieloneswiatki.getFullYear(), zieloneswiatki.getMonth() + 1, zieloneswiatki.getDate()],
                bozecialo: [bozecialo.getFullYear(), bozecialo.getMonth() + 1, bozecialo.getDate()]
            };
        }
        if (easter.wielkanoc[1] == m && easter.wielkanoc[2] == d)
            return "Wielkanoc";
        if (easter.poniedzialek[1] == m && easter.poniedzialek[2] == d)
            return "Poniedziałek Wielkanocny";
        if (easter.zieloneswiatki[1] == m && easter.zieloneswiatki[2] == d)
            return "Zielone Świątki";
        if (easter.bozecialo[1] == m && easter.bozecialo[2] == d)
            return "Boże Ciało";
    }
    return "";
}
exports.default = dateHoliday;
//# sourceMappingURL=dateHoliday.js.map